import { useEffect } from "react";
import classNames from "classnames";
import { Dialog, Html5VideoPlayer } from "@kunduz/ui";
import styles from "./learningAdaptiveTestFooter.module.scss";
import ImgViewIcon from "@icons/learning_adaptive_view_img.svg";
import VideoViewIcon from "@icons/learning_adaptive_view_video.svg";
import BottomCorrectIcon from "@icons/learning_adaptive_correct_bottom.svg";
import BottomWrongIcon from "@icons/learning_adaptive_wrong_bottom.svg";
import CloseIcon from "@icons/learning_adaptive_close.svg";
import { ILearning } from "@kunduz/data-access-learning-api";

// TODO: refactor dialog component

export const LearningAdaptiveTestFooter = (props: Props) => {
  const {
    isCorrect,
    answer,
    correctChoiceLabel,
    isMobile,
    adaptiveTestMutate,
    setTestOrder,
    testOrder,
    onAnswerResultScreenVisited,
    onAnswerViewed,
    onContinueButtonClicked,
    setScreenState,
    correctMessage,
    wrongMessage,
    viewAnswerPopupTitle,
    correctChoiceMessage,
    answerButtonLabel,
    continueButtonLabel,
  } = props;

  useEffect(() => {
    onAnswerResultScreenVisited();
  }, []);

  const AnswerTypeIcon = answer?.is_video ? VideoViewIcon : ImgViewIcon;
  const AnswerIcon = isCorrect ? BottomCorrectIcon : BottomWrongIcon;
  const labelText = isCorrect ? correctMessage : wrongMessage;

  const fetchNextQuestion = () => {
    setTestOrder(testOrder + 1);
    adaptiveTestMutate();
    setScreenState("question");
    onContinueButtonClicked();
  };

  const viewAnswerOnClick = () => onAnswerViewed();

  const isServer = () => typeof window === `undefined`;

  const renderAnswerContent = () => (
    <>
      <div className={styles["viewAnswer"]}>{viewAnswerPopupTitle}</div>
      {answer?.is_video ? (
        <Html5VideoPlayer
          isMobile={isMobile}
          videoUrl={answer?.media}
          className={styles["view"]}
          playbackSpeedBuildLabel={props.playbackSpeedBuildLabel}
          settingsLabel={props.settingsLabel}
          handleVideoEnded={props.handleVideoEnded}
        />
      ) : (
        <img
          className={styles["view"]}
          src={answer?.media}
          alt="answer"
          loading="lazy"
        />
      )}
    </>
  );

  return (
    <div
      className={classNames(
        styles["container"],
        isCorrect ? styles["correct"] : styles["wrong"],
      )}
    >
      <div className={styles["content"]}>
        <div className={styles["iconContainer"]}>
          <AnswerIcon />
          <div
            className={classNames(
              styles["correctOption"],
              isCorrect ? styles["correct"] : styles["wrong"],
            )}
          >
            <span>{labelText}</span>
            <span>
              {correctChoiceMessage} {correctChoiceLabel}
            </span>
          </div>
        </div>
        <div className={styles["actionContainer"]}>
          <Dialog
            triggerNode={
              answer && (
                <button
                  className={styles["answerButton"]}
                  onClick={viewAnswerOnClick}
                >
                  <AnswerTypeIcon />
                  {answerButtonLabel}
                </button>
              )
            }
            contentNode={renderAnswerContent()}
            contentClassName={styles["answerContainer"]}
            closeNode={
              <div className={styles["closeIcon"]}>
                <CloseIcon />
              </div>
            }
          />

          <button
            className={classNames(
              styles["continueButton"],
              isCorrect ? styles["correct"] : styles["wrong"],
            )}
            onClick={fetchNextQuestion}
          >
            {continueButtonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

interface Props {
  isCorrect: boolean;
  answer?: ILearning.LearningAdaptiveTestAnswer;
  correctChoiceLabel: string;
  isMobile: boolean;
  adaptiveTestMutate: () => void;
  testOrder: number;
  setTestOrder: (e: number) => void;
  onAnswerResultScreenVisited: () => void;
  onContinueButtonClicked: () => void;
  onAnswerViewed: () => void;
  setScreenState: (e: "question" | "answer_selected" | "answer_result") => void;
  playbackSpeedBuildLabel: string;
  settingsLabel: string;
  correctMessage: string;
  wrongMessage: string;
  correctChoiceMessage: string;
  answerButtonLabel: string;
  continueButtonLabel: string;
  viewAnswerPopupTitle: string;
  handleVideoEnded?: () => void;
}
